import { useMediaQuery, useTheme } from '@mui/material'

/**
 * Returns true when the viewport is below the 'sm' breakpoint (600px).
 * Use this for conditional rendering that differs between mobile and desktop.
 */
export function useIsMobile(): boolean {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down('sm'))
}
